import React, {lazy, Suspense} from 'react';
import { render } from 'react-dom';

/* Components */
const ExtranetVehicle = lazy(() => import(/* webpackChunkName: "ExtranetVehicle" */ './components/ExtranetVehicle'));

const containers = document.querySelectorAll('.extranet-vehicle');

// Render each component
for (let i = 0; i < containers.length; i++) {
    let el = containers[i];
    let props = {};

    // Parse dataset to valid props
    for(let key in el.dataset) {
        props[key] = el.dataset[key];

        // Try to parse string to literal
        // Will parse: array, boolean, null, number, object and string
        try {
            props[key] = JSON.parse(props[key]);
        }
        catch(e) {} // eslint-disable-line no-empty
    }

    // Render component
    render(
        <Suspense fallback={<></>}>
            <ExtranetVehicle
                {...props}
                element={el}
            />
        </Suspense>,
        el
    );
}
